import styled from '@emotion/styled'

export const Overlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
`

export const Text = styled.div(
  ({ theme }) => `
  color: ${theme.ds.ColorBaseWhite};
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 1px;
  line-height: 22px;
  text-align: center;
`
)

export const Logo = styled.div`
  margin-bottom: 20px;
`
